import { ResubmitOrderResponseModel } from "@dana/Types/ApiModels";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

// Define the state type for this fetch workflow
export interface OrdersVerifyDetailState  {
    isLoading: boolean,
    data: ResubmitOrderResponseModel | null,
    error: string | null,
}

const initialOrdersVerifyState:OrdersVerifyDetailState = {
    isLoading: false,
    data: null,
    error: null
};

// Create Immer reducer
const ordersVerifyReducer = createTypedReducerWithImmer(initialOrdersVerifyState, {
    // Start loading
    "OrdersVerify/IsLoading": (draft, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null; // Optionally reset error if reloading
        }
    },

    // Populate result on success
    "OrdersVerify/PopulateResult": (draft, action: { data: any }) => {
        draft.data = action.data;
        draft.isLoading = false;
        draft.error = null;
    },

    // Handle error
    "OrdersVerify/FetchError": (draft, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    // Reset all state (optional)
    "OrdersVerify/Reset": draft => {
        draft.isLoading = false;
        draft.data = null;
        draft.error = null;
    }
});

// Register reducer in the root
(reducers as any).ordersVerify = ordersVerifyReducer;

// Define type for action usage
type OrderVerifyReducers = {
    ordersVerify: typeof ordersVerifyReducer;
};

export type OrdersVerifyActions = Parameters<OrderVerifyReducers[keyof OrderVerifyReducers]>[1] | AnyAction;